import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  position: relative;
`;

export default Container;
